import { z } from "zod";

/**
 * Row shape returned by GET /api/pairs/:id/trades.
 *
 * Mirrors the `trades` D1 table (migration 0001 lines 82–95) with a
 * handful of join fields so the dashboard doesn't need a second
 * round-trip to label each row (firm_name comes from the account's
 * firm_id → firms join; login is the broker account number).
 */
export const TradeRowZ = z.object({
  id: z.string(),
  account_id: z.string(),
  pair_id: z.string(),
  ticket: z.number().int(),
  symbol: z.string(),
  side: z.enum(["buy", "sell"]),
  lots: z.number(),
  entry_price: z.number(),
  /** NULL while the position is still open. */
  close_price: z.number().nullable(),
  /** Realized PnL once closed_at is set; live unrealized PnL is NOT
   *  surfaced here — that lives on the WS (account:tick / position:update). */
  pnl: z.number().nullable(),
  opened_at: z.number().int(),
  closed_at: z.number().int().nullable(),
  // ── Join fields for display (not columns on the trades table) ──
  firm_name: z.string().nullable(),
  login: z.string().nullable(),
});
export type TradeRow = z.infer<typeof TradeRowZ>;

export const ListTradesResZ = z.object({
  trades: z.array(TradeRowZ),
});
export type ListTradesRes = z.infer<typeof ListTradesResZ>;
